import { connect } from 'react-redux'
import ImageSelector from './image-selector'
import { getPresentation } from '../../stores/presentation/presentation.selectors'

const mapStateToProps = state => ({
  presentation: getPresentation(state)
})

export default connect(
  mapStateToProps,
  null
)(ImageSelector)
